/* eslint-disable */
"use client";

import * as React from "react";
import createIcon from "../Icon/createIcon";
export default createIcon( /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  d: "M7.906 3.015c1.382.106 2.78.786 4.1 2.09 1.32-1.304 2.717-1.982 4.097-2.086 1.657-.125 3.103.591 4.13 1.681 2 2.124 2.636 5.957.14 8.615a.96.96 0 0 1-.034.035L12.7 20.72a1 1 0 0 1-1.388 0l-7.64-7.37a.977.977 0 0 1-.034-.035c-2.507-2.67-1.875-6.504.132-8.627 1.03-1.09 2.478-1.801 4.136-1.673Z"
})), "0 0 24 24", "Heart");